export default "__VITE_ASSET__DQlzK_Py__"